import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import { initThemeFromStorage } from '@/lib/theme'
import { configureCatalogFromEnv } from '@/lib/catalogRepository'
import App from './App.tsx'

// 初回描画前に保存済みモードのテーマを適用（色のちらつき防止）
initThemeFromStorage()

// 検索APIのURLが設定されている場合のみ HTTP リポジトリへ切り替える（未設定ならデモデータ）
configureCatalogFromEnv()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// 開発時のみ: ?selftest=1 で価格・発売日・IDの境界値テストをコンソールに出力
if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('selftest')) {
  void import('@/lib/selfTest').then((module) => module.runSelfTest())
}